// extracted by mini-css-extract-plugin
export default {"mainContainer":"price_filter_mainContainer__WFkyd","title":"price_filter_title__AWTTm","priceInput":"price_filter_priceInput__HSpXF"};